import React, { useEffect, useRef } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  saveNewTask,
  removeBlankTask,
  resolveTask,
  setNewTaskName,
} from "shared/itemLists/redux/itemListsSlice";

function NewTask({
  details,
  setNewTask,
  setCursorIndex,
  saveNewTask,
  newTask,
  removeBlankTask,
  removeEmptyDay,
  setNewTaskName,
}) {
  const nameInput = useRef(null);
  useEffect(() => {
    nameInput.current.focus();
  }, []);

  function handleTaskNameChange(event) {
    const newName = event.target.value;
    setNewTaskName(newName);
  }

  function handleKeyDown(event) {
    if (event.key === "Enter") {
      saveNewTask({ method: "enter" });
    }
    if (event.key === "Backspace" && newTask.name === "") {
      removeBlankTask({ method: "keystroke" });
    }
  }

  return (
    <div className="item Task flexible New-task">
      <input
        ref={nameInput}
        className="item-txtstyl"
        onChange={handleTaskNameChange}
        onKeyDown={handleKeyDown}
        value={newTask.name}
      ></input>
    </div>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { saveNewTask, removeBlankTask, resolveTask, setNewTaskName },
    dispatch
  );
}

export default connect(null, mapDispatchToProps)(NewTask);
